import React, { useEffect, useState } from "react";
import MagicLinkInput from "../MagicLinkInput";
import { isValidLink } from "../../../Services/utils";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import {
    addLinkToNonStoreSectionsWrapper,
    addLinkToStoreSectionsWrapper,
    getLinkData,
    getLinkDataMobile
} from "../../../Services/apiServices/linkService";
import {
    addLinkToNonStoreSections,
    setMagicButtonState,
    setMagicLinkInput,
    setMagicLinkInputCopy,
    setSelectedLinkInBio
} from "../../../redux/slice/dashboardSlice";
import { magicButtonStates } from "../../../enums";
import { message } from "antd";
import CopyToClipboard from "../../../assets/copyPaste.png";

const index = ({ screen }) => {
    const dispatch = useDispatch();
    const { magicButtonState, magicLinkResponse, magicLinkInput, selectedCollection, selectedLinkInBio } = useSelector(
        (state) => state.root.dashboard
    );
    const [isValidMagicLink, setIsValidMagicLink] = useState(true);
    const [magicLinkButtonClick, setMagicLinkButtonClick] = useState(false);
    useEffect(() => {
        if (magicButtonState === magicButtonStates.INITIAL) {
            setMagicLinkInput("");
        }
    }, [magicButtonState]);

    const handleKeyDown = async (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            setIsValidMagicLink(isValidLink(magicLinkInput, ""));
            if (isValidLink(magicLinkInput, "")) {
                e.target.blur();
                await getLinkDataMobile(magicLinkInput);
                setMagicLinkInput("");
            } else {
                setMagicButtonState(magicButtonStates.INVALID);
                message.error("This type of link doesn't belong to this section.");
            }
        }
    };

    const handleCopyPaste = async () => {
        try {
            const permission = await navigator.permissions.query({ name: "clipboard-read" });
            if (permission.state === "granted" || permission.state === "prompt") {
                if (navigator.clipboard) {
                    // Read text from the clipboard
                    const clipboardText = await navigator.clipboard.readText();
                    dispatch(setMagicLinkInput(clipboardText));
                    dispatch(setMagicLinkInputCopy());
                    setIsValidMagicLink(isValidLink(clipboardText, ""));
                    if (isValidLink(clipboardText, "")) {
                        await getLinkDataMobile(clipboardText);
                    } else {
                        dispatch(setMagicButtonState(magicButtonStates.INVALID));
                        message.error("Invalid link");
                    }
                } else {
                    message.error("Can't paste text from clipboard");
                    console.log("Clipboard API not supported in this browser");
                }
            } else {
                message.error("Insufficient permissions");
            }
        } catch (err) {
            console.error("Failed to read clipboard contents: ", err);
        }
    };

    const handleOnChange = (e) => {
        if (e.target.value === "") {
            setIsValidMagicLink(true);
        }
        dispatch(setMagicLinkInput(e.target.value));
        dispatch(setMagicLinkInputCopy());
    };

    return (
        <div className={styles.magicLinkContainer}>
            <div className={styles.magicLinkHeading}>{screen === "LinkInBio" ? "Enter Link" : "Enter poduct URL"}</div>
            <div className={styles.inputsContainer}>
                <MagicLinkInput handleKeyDown={handleKeyDown} handleOnChange={handleOnChange} />
                <img src={CopyToClipboard} className={styles.copyPasteFromClipboard} onClick={handleCopyPaste} />
            </div>
        </div>
    );
};

export default index;
